module.exports = __webpack_public_path__ + "static/img/partner_13.f47751c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_13.png
// module id = lFpx
// module chunks = 0